import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const OrdersTranslations = wrapTranslationsSchema({
	name: 'OrdersTranslations',
	title: 'Orders Translations',
	sanityId: 'orders',
	fields: {
		purchaseConfirmationTitle: 'Order Confirmation',
		purchaseConfirmationMessage:
			'You are now ordering this item and sending it for the fulfillment.',
		purchaseOpen: 'Open',
		purchaseClosed: 'Closed',
		purchaseAdditionalInformationTitle: 'Additional Required Information',
		order: 'Order',
		submitted: 'Submitted',
		submittedOn: 'Submitted on',
		total: 'Total',
		submissionStatus: 'Submission status',
		submissionFailedMessage:
			'The item has been moved to the cart. To resubmit, please go to the cart and try checking out again.',
		quickBuysubmissionFailedMessage: 'To resubmit, please try purchasing again.',
		fulfillmentStatus: 'Fulfillment status',
		purchaseOrdersNotification:
			"You can find your Marketplace Requests here. If you're looking for Purchase Requests, go to {buyEasy}.",
		buyEasy: 'BuyEasy',
		complete: 'Complete',
		partial: 'Partial',
		failed: 'Failed',
		orderStatus: 'Order status',
		itemStatus: 'Item status',
		lastUpdated: 'Last Updated',
		refreshing: 'Updating...',
		updated: 'Updated',
		viewIn: 'View in',
		noOrders: 'You have no requests yet.',
		failedToLoadOpenOrders: 'Something went wrong while loading open requests.',
		failedToLoadClosedOrders: 'Something went wrong while loading closed requests.',
		failedToLoadOrders: 'Something went wrong while loading requests, please try again later.',
		ordersTitleOpen: 'Open Requests',
		ordersTitleClosed: 'Closed Requests',
		price: 'Price',
		orderSummary: 'Request summary',
		fulfillmentDetails: 'Details',
		details: 'Details',
		orderNumber: 'Order number',
		requestNumber: 'Request number',
		requestedFor: 'Requested for',
		requestedBy: 'Requested by',
		estimatedFulfillmentTime: 'Estimated fulfillment time',
		storeLabel: 'Store',
		noClosedOrders: 'No closed orders',
		noOpenOrders: 'No open orders',
		requestModalTitle: 'Order request sent',
		requestModalContinue: 'Continue browsing',
		requestModalGoToOrders: 'Go to orders',
		requestModalRequestedFor: 'Requested for:',
		requestModalPrice: 'Price:',
		requestModalOrderNumber: 'Order number:',
		requestModalDetails: 'Details:',
		requestModalItemMovedToSavedForLaterMessage:
			'The item has been moved to your Saved for Later list.',
		requestModalDetailsMessage:
			'Error returned from the fulfillment system. The item has been moved to your Saved for Later list.',
		requestModalStore: 'Store:',
		requestModalGoToSaveForLater: 'Go to Saved for later',
		pleaseSubmitYourOrderAgain: 'Please submit your order again.',
		na: 'N/A',
		askQuestion: 'Ask a question',
	},
});
